const routes = {
  vehicleList: 'vehicle-list',
  selectionList: 'selection-list',
  history: 'history',
}

const defaultRoute = routes.vehicleList

export { routes, defaultRoute }
